import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { LogOut, ClipboardCheck, Map, Shield, Users, Building2, Database } from 'lucide-react';

const AdminNav = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.75rem 1.25rem',
    background: '#1e3a5f',
    color: '#fff',
    flexWrap: 'wrap',
  };

  const linkStyle = (path) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.375rem',
    padding: '0.375rem 0.75rem',
    borderRadius: '0.375rem',
    cursor: 'pointer',
    background: isActive(path) ? 'rgba(255,255,255,0.2)' : 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: '0.875rem',
    fontWeight: isActive(path) ? '600' : '400',
    textDecoration: 'none',
  });

  const isAdmin = user?.role === 'admin';

  return (
    <nav style={navStyle} aria-label="Admin Navigation">
      <span style={{ fontWeight: 700, marginRight: '0.5rem', fontSize: '0.95rem' }}>
        Grosskinder Admin
      </span>

      <button style={linkStyle('/moderation')} onClick={() => navigate('/moderation')}>
        <Shield size={15} />
        Moderation
      </button>

      <button style={linkStyle('/aktivitaeten-pruefen')} onClick={() => navigate('/aktivitaeten-pruefen')}>
        <ClipboardCheck size={15} />
        Aktivitäten prüfen
      </button>

      <button style={linkStyle('/aktivitaeten-karte')} onClick={() => navigate('/aktivitaeten-karte')}>
        <Map size={15} />
        Orte der Aktivitäten
      </button>

      <button style={linkStyle('/aktivitaeten-nach-ort')} onClick={() => navigate('/aktivitaeten-nach-ort')}>
        <Building2 size={15} />
        Aktivitäten nach Ort
      </button>

      <button style={linkStyle('/quellen')} onClick={() => navigate('/quellen')}>
        <Database size={15} />
        Quellen
      </button>

      {isAdmin && (
        <button style={linkStyle('/benutzerverwaltung')} onClick={() => navigate('/benutzerverwaltung')}>
          <Users size={15} />
          Benutzerverwaltung
        </button>
      )}

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ fontSize: '0.8rem', opacity: 0.8 }}>
          {user?.vorname || user?.username || user?.email}
        </span>
        <button
          style={{ ...linkStyle(''), background: 'rgba(255,255,255,0.1)' }}
          onClick={logout}
        >
          <LogOut size={15} />
          Ausloggen
        </button>
      </div>
    </nav>
  );
};

export default AdminNav;
